import { TranslationKey } from "src/types/translationKey";

/**
 * The Payer IDs.
 * Defines the payer of the subscription.
 * - Used in the metadata of the purchase items.
 *    - "partner.payer": "79a815d6-262c-46e4-a20d-d942b79f8fee"
 * CASH_PAY = user pays with credit card
 * OTHER = users insurance or employer pays
 */
export enum PayerId {
  CASH_PAY = "79a815d6-262c-46e4-a20d-d942b79f8fee",
  TRANSCARENT = "9c201a22-bd05-41c8-b885-ab17b1c73330",
  EVERNORTH = "2c31438e-af1e-4401-a676-6925227992d2",
  GEORGIA = "3a437954-5990-4359-86e4-a4d877a012f6",
  // Confirmed against BACK-5877's merged backend definition
  // (`PartnerConstants.PERSONIFY_HEALTHPLAN`, commit b5c0629b2c) — matches.
  PERSONIFY_HEALTH = "62999ec0-cfe1-422c-8a4f-650b9c99977f"
}

/**
 * Employer partner UUIDs — identifies a member's direct employer.
 * Check via userState.isEmployerMember(EmployerId.X).
 */
export enum EmployerId {
  BANK_OF_NEW_YORK = "dd06daf1-7c80-4482-836b-634709e80fac",
  KWIK_TRIP = "287fcc30-03df-45f0-a00f-7f4b2814da0d"
}

/**
 * Maps payer IDs to their additional legal text translation keys.
 * Add new payers here when they require custom legal text on checkout.
 */
export const PayerAdditionalLegalTextKey: Partial<
  Record<PayerId, TranslationKey>
> = {
  [PayerId.GEORGIA]: "signup.legalText_stateOfGeorgia"
};
